const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M497 91.982H15c-8.284 0-15 6.716-15 15v298.036c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V106.982c0-8.284-6.716-15-15-15ZM30 218.508c50.073-6.7 89.826-46.453 96.526-96.526h258.947c6.7 50.073 46.453 89.826 96.527 96.526v74.984c-50.074 6.7-89.827 46.453-96.527 96.526H126.526c-6.7-50.073-46.453-89.826-96.526-96.526v-74.984Zm452-30.389c-33.498-6.179-59.958-32.639-66.138-66.137H482v66.137ZM96.137 121.982C89.958 155.48 63.498 181.94 30 188.119v-66.137h66.137ZM30 323.881c33.498 6.179 59.958 32.639 66.137 66.137H30v-66.137Zm385.862 66.137c6.179-33.498 32.64-59.958 66.138-66.137v66.137h-66.138Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    },
    transform: "rotate(.428) scale(.04297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 151c24.813 0 45 20.187 45 45 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-41.355-33.645-75-75-75s-75 33.645-75 75v45h-15c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h15c-.267 1.404 3.046 35.742-25.606 64.393C145.976 344.81 152.646 361 166 361h150c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H196.061c16.632-29.578 14.798-58.837 14.939-60h45c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15h-45v-45c0-24.813 20.187-45 45-45Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    },
    transform: "matrix(.03333 0 0 .03333 2.967 2.967)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlack);
export default __webpack_public_path__ + "static/media/paymentBlack.db77e083e2854f970e46314dae467143.svg";
export { ForwardRef as ReactComponent };